export default __webpack_public_path__ + "static/media/Fast.740d0fa4.svg";